import { render, staticRenderFns } from "./ModalSubarea.vue?vue&type=template&id=2ca2c148"
import script from "./ModalSubarea.vue?vue&type=script&lang=js"
export * from "./ModalSubarea.vue?vue&type=script&lang=js"
import style0 from "./ModalSubarea.vue?vue&type=style&index=0&id=2ca2c148&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports